  // Toggle parent status handler for slide toggle in parent card

import { Component, OnInit, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonService } from '../services/common.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
// import { Overlay } from '@angular/cdk/overlay';
import { NewauditComponent } from '../newaudit/newaudit.component';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TabChangeService } from 'src/app/services/tab-change.service';
import { ModalTabVisibilityService } from '../services/modal-tab-visibility.service';

export interface VAEventInfo {
  Id: number;
  EventType: string;
  SourceAgent: string;
  MessageType: string;
  DXEndPoint: string;
  Status: string;
  Deployment: string;
  ModifierID: string;
}

@Component({
  selector: 'app-eventinfo',
  templateUrl: './eventinfo.component.html',
  styleUrls: ['./eventinfo.component.scss']
})
export class EventinfoComponent implements OnInit, OnDestroy {
 
  openDeploymentDropdown(autocompleteRef: any) {
    if (autocompleteRef && typeof autocompleteRef.showDropdown === 'function') {
      autocompleteRef.showDropdown();
    }
  }
  selectdeploymentEvent(item: any) {
    this.deploymentSelected = item;
    this.getAgentByDeploymentAndDirection();
  }
  resetPage(resetEventInfoList: boolean = true, resetSelectedCard: boolean = true): void {
    this.EventInfoFilterForm.reset({
      eventType: '',
      deployment: '',
      status: '',
      dxEndpoint: '',
      messageType: ''
    });

    this.eventInfoForm.reset({
      eventType: '',
      deployment: '',
      status: false,
      dxEndpoint: '',
      messageType: '',
      frequency: ''
    });

    this.selectedChildRowId = null; // Always reset for parent edits
    this.selectedAgentguid = '';
    this.deploymentSelected = '';
    this.selectedId = 0;

    if (resetEventInfoList) {
      this.vaEventInfoList = { ParentEventInfo: [], ChildEventsInfo: [] };
    }
    if (resetSelectedCard) {
      this.selectedCardId = null;
    }
    // Collapse all expanded parent cards
    this.expandedParentIds.clear();
    this.ngxUiLoaderService.stop();
  }
  frequencyList: { displayname: string }[] = [];
  searchkeyword: string = 'displayname';
  parentJobLogs: { [jobId: string]: any[] } = {};

  fetchParentJobLogs(jobId: string): void {
    this.parentJobLogs[jobId] = [];
    this.ngxUiLoaderService.start();
    this.service.getJobLogs(jobId, 1, 10).subscribe({
      next: (data) => {
        this.parentJobLogs[jobId] = data;
        if (!data || (Array.isArray(data) && data.length === 0)) {
          this.toastr.warning('No job logs found', '', { timeOut: 4000, positionClass: 'toast-bottom-right' });
        }
        this.ngxUiLoaderService.stop();
      },
      error: () => {
        this.parentJobLogs[jobId] = [];
        this.ngxUiLoaderService.stop();
        this.toastr.error("Logs Not Found", "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
      }
    });
  }
  /**
   * Opens the audit modal for parent or child event info.
   * @param id The unique id (EventMapID or EventSourceMapID)
   * @param guid The guid (EventMapID or EventSourceMapID)
   * @param title The event type or message type
   */
  
  selectedChildRowId: number | null = null;
  expandedParentIds: Set<number> = new Set();
  isParentAdd: boolean = false;
  isChildAdd: boolean = false;
eventType:FormControl = new FormControl('');
deployment:FormControl = new FormControl('');
frequencydisplayname:FormControl = new FormControl('');

  toggleChild(parentId: number): void {
    if (this.expandedParentIds.has(parentId)) {
      this.expandedParentIds.delete(parentId);
    } else {
      this.expandedParentIds.add(parentId);
    }
  }
  getChildEventsForParent(parentId: number) {
    return this.vaEventInfoList.ChildEventsInfo.filter(c => c.EventSourceMapID === parentId);
  }

  EventInfoFilterForm: FormGroup;
  eventInfoForm: FormGroup;
  public reactiveFormdeployment: FormGroup;
  selectedCardId: number | null = null;
  deploymentItemsList = [];
  frequencyItemsList: string[] = ['Hourly', 'Daily', 'Weekly', 'Monthly'];
  selectedAgentguid: string = '';
  selectedId: number = 0;
  statusvalue: string = '';
  deploymentSelected: string = '';
  vaEventInfoList: { ParentEventInfo: any[]; ChildEventsInfo: any[] } = { ParentEventInfo: [], ChildEventsInfo: [] };
  keyword = "value";
  pagerolepermisions: any = [];
  agenttitle: string = ''; // restored for modal title

  public status = [
    { name: 'true', value: 'Active' },
    { name: 'false', value: 'Passive' }
  ];
  
  // Modal tab management
  private destroy$ = new Subject<void>();
  private tabChangeSubscription: Subscription;
  private componentName = 'event info';
  private isActiveTab = true;
  private modalWasOpen = false;
  private currentModalRefs: any[] = [];

  constructor(
    private fb: FormBuilder,
    private service: CommonService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    public dialog: MatDialog,
    // private overlay: Overlay,
    private tabChangeService: TabChangeService,
    private modalTabVisibility: ModalTabVisibilityService
  ) {
    // Filter form
    this.EventInfoFilterForm = this.fb.group({
      eventType: [''],
      deployment: [''],
      status: [''],
      dxEndpoint: [''],
      messageType: [''],
      
    });
    this.reactiveFormdeployment = this.fb.group({ deploymentname: ['', Validators.required] });
    

    // Modal form
    this.eventInfoForm = this.fb.group({
      eventType: [''],
      deployment: [''],
      status: [false],
      dxEndpoint: [''],
      messageType: ['', Validators.required],
      frequencydisplayname: ['']
    });
  }
@ViewChild('parentJobLogsModal', { static: true }) parentJobLogsModal: TemplateRef<any>;
modalJobLogs: any[] = [];
modalJobName: string = '';
modalJobId: string = '';
  ngOnInit() {
    this.getFrequencyList();
    this.getDeployments();
    this.reactiveFormdeployment.patchValue({ "deploymentname": this.deploymentSelected });
    const roleMenus = JSON.parse(sessionStorage.getItem('rolewithmenus') || '[]');
    const selectedRole = sessionStorage.getItem('SelectedUserRole') || '';
    const menuid = roleMenus.find((x: any) => x.RoleName == selectedRole)?.menuslist?.find((y: any) => y.MenuName == 'EventInfo')?.MenuId;
    const actionitems = roleMenus.find((x: any) => x.RoleName == selectedRole)?.menuslist?.filter((y: any) => y.ParentMenuId == menuid) || [];
    actionitems.forEach(element => {
      this.pagerolepermisions[element.MenuName] = true;
    });
    
    // Subscribe to tab changes
    this.tabChangeSubscription = this.tabChangeService.tabChange$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((tabName: string) => {
      this.isActiveTab = tabName.toLowerCase() === this.componentName.toLowerCase();
      setTimeout(() => {
        if (this.isActiveTab) {
          this.modalTabVisibility.hideForeignOwnedModals('data-eventinfo-modal');
          this.showModals();
        } else {
          this.hideModals();
        }
      }, 0);
    });
  }
  
  ngOnDestroy() {
    // Close all open modals when component is destroyed
    if (this.currentModalRefs && this.currentModalRefs.length > 0) {
      this.currentModalRefs.forEach(modalRef => {
        if (modalRef) {
          try {
            modalRef.close();
          } catch (e) {
            // Modal might already be closed, ignore error
          }
        }
      });
      this.currentModalRefs = [];
    }
    
    this.destroy$.next();
    this.destroy$.complete();
    if (this.tabChangeSubscription) {
      this.tabChangeSubscription.unsubscribe();
    }
  }

  showParentJobLogs(jobId: string, eventType: string, jobName: string) {
    this.ngxUiLoaderService.start();
    this.service.getJobLogs(jobId, 1, 10).subscribe({
      next: (data) => {
        this.parentJobLogs[jobId] = data;
        this.modalJobLogs = data || [];
        this.modalJobName = jobName;
        this.modalJobId = jobId;
        this.ngxUiLoaderService.stop();
        const jobLogsModalRef1 = this.modalService.open(this.parentJobLogsModal, {
          windowClass: 'job-logs-modal',
          size: 'lg',
          backdrop: 'static'
        });
        this.currentModalRefs.push(jobLogsModalRef1);
        
        jobLogsModalRef1.result.then(
          (result) => {
            this.modalWasOpen = false;
            this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== jobLogsModalRef1);
          },
          (reason) => {
            this.modalWasOpen = false;
            this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== jobLogsModalRef1);
          }
        );
        
        this.modalTabVisibility.tagOwned('data-eventinfo-modal', 'job-logs-modal');
        
        this.modalWasOpen = true;
      },
      error: () => {
        this.parentJobLogs[jobId] = [];
        this.modalJobLogs = [];
        this.modalJobName = jobName;
        this.modalJobId = jobId;
        this.ngxUiLoaderService.stop();
        this.toastr.error("Logs Not Found", "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
        const jobLogsModalRef2 = this.modalService.open(this.parentJobLogsModal, {
          windowClass: 'job-logs-modal',
          size: 'lg',
          backdrop: 'static'
        });
        this.currentModalRefs.push(jobLogsModalRef2);
        
        jobLogsModalRef2.result.then(
          (result) => {
            this.modalWasOpen = false;
            this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== jobLogsModalRef2);
          },
          (reason) => {
            this.modalWasOpen = false;
            this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== jobLogsModalRef2);
          }
        );
        
        this.modalTabVisibility.tagOwned('data-eventinfo-modal', 'job-logs-modal');
        
        this.modalWasOpen = true;
      }
    });
  }

  getFrequencyList() {
    const apiname = 'api/Lookup/GetLookUpId?lookuptype=jobtrigger';
    this.service.getapiurl(apiname).subscribe({
      next: (data: any[]) => {
        this.frequencyList = data.map(item => ({ displayname: item }));
      }
    });
  }

  cleareddeployment(event) {
    this.deploymentSelected = '';
    this.selectedAgentguid = '';
     this.reactiveFormdeployment.reset();
    this.reactiveFormdeployment.patchValue({ "deploymentname": '' });
    this.reactiveFormdeployment.patchValue(this.deploymentItemsList);
 
  }

  getDeployments() {
    this.service.getDeployments("Deployments").subscribe(
      (data) => {
        this.deploymentItemsList = data.length > 0 ? data : [];
      },
      () => {
        this.toastr.error("Something went wrong", "", { timeOut: 4000, positionClass: "toast-bottom-right" });
      }
    );
  }

  getAgentByDeploymentAndDirection(): void {
    if (!this.deploymentSelected) return;
    const direction = 'Outbound';
    this.service.GetAgentByDirectionAndDeployment(direction, this.deploymentSelected).subscribe({
      next: (response: any[]) => {
        this.selectedAgentguid = (response && response.length > 0) ? response[0].id : '';
      },
      error: () => { this.selectedAgentguid = ''; }
    });
  }

  getVAEventInfo(resetHighlight: boolean = false): void {
    // Collapse all expanded parent cards on new search
    this.expandedParentIds.clear();
    this.ngxUiLoaderService.start();
    this.vaEventInfoList = { ParentEventInfo: [], ChildEventsInfo: [] };
    if (resetHighlight) this.selectedCardId = null;

    const requestBody: VAEventInfo = {
      Id: this.selectedId,
      EventType: this.EventInfoFilterForm.value.eventType,
      SourceAgent: this.selectedAgentguid,
      MessageType: this.EventInfoFilterForm.value.messageType,
      DXEndPoint: (this.EventInfoFilterForm.value.dxEndpoint || '').trim(),
      Status: this.statusvalue,
      Deployment: this.deploymentSelected,
      ModifierID: JSON.parse(sessionStorage.getItem('sessionObjectlogin') || '{"userdata":{}}').userdata['userid']
    };

    this.service.GetVAEventInfo(requestBody).subscribe({
      next: (response: any) => {
        if (response && response.status === 'success' && response.responsebody) {
          this.vaEventInfoList = {
            ParentEventInfo: Array.isArray(response.responsebody.ParentEventInfo) ? response.responsebody.ParentEventInfo : [],
            ChildEventsInfo: Array.isArray(response.responsebody.ChildEventsInfo) ? response.responsebody.ChildEventsInfo : []
          };
          if ((this.vaEventInfoList.ParentEventInfo.length === 0) && (this.vaEventInfoList.ChildEventsInfo.length === 0)) {
            this.toastr.warning('No data found', '', { timeOut: 4000, positionClass: 'toast-bottom-right' });
          }
          console.log('Fetched ChildEventsInfo:', this.vaEventInfoList.ChildEventsInfo);
        } else {
          this.vaEventInfoList = { ParentEventInfo: [], ChildEventsInfo: [] };
          this.toastr.warning('No data found', '', { timeOut: 4000, positionClass: 'toast-bottom-right' });
        }
        this.ngxUiLoaderService.stop();
      },
      error: () => {
        this.vaEventInfoList = { ParentEventInfo: [], ChildEventsInfo: [] };
        this.ngxUiLoaderService.stop();
        this.toastr.error('Error occurred while fetching VA Event Info.', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
    });
  }

  openAddOrEditEventInfo(eventInfo: any, modal: any): void {
    
    this.resetPage(false, false);
    this.eventInfoForm.reset();

    // Always patch all fields for consistency
    if (eventInfo) {
      this.isParentAdd = false;
      this.isChildAdd = false;
      if (eventInfo.EventSourceMapID) {
        // Editing child event
        this.agenttitle = "Edit Child Event Info";
        const parent = this.vaEventInfoList.ParentEventInfo.find(p => p.EventMapID === eventInfo.EventSourceMapID);
        this.eventInfoForm.patchValue({
          eventType: parent?.EventType || '',
          deployment: parent?.Deployment || '',
          status: eventInfo.Status === true || eventInfo.Status === 'True',
          dxEndpoint: parent?.DXEndPoint ?? '',
          messageType: eventInfo.MessageType,
          frequencydisplayname: parent?.Frequency || ''
        });
        this.selectedChildRowId = eventInfo.ChildRowId;
        this.selectedId = 0;
        this.selectedAgentguid = parent ? parent.SourceAgent : '';
        this.deploymentSelected = parent ? parent.Deployment : '';
        // Disable parent fields for child edit
        this.eventInfoForm.get('eventType')?.disable({ emitEvent: false });
        this.eventInfoForm.get('deployment')?.disable({ emitEvent: false });
        this.eventInfoForm.get('dxEndpoint')?.disable({ emitEvent: false });
        this.eventInfoForm.get('frequencydisplayname')?.disable({ emitEvent: false });
      } else {
        // Editing parent event
        this.agenttitle = "Edit Event Info";
        this.eventInfoForm.patchValue({
          eventType: eventInfo.EventType,
          deployment: eventInfo.Deployment,
          status: eventInfo.Status === true || eventInfo.Status === 'True',
          dxEndpoint: eventInfo.DXEndPoint ?? '',
          messageType: eventInfo.MessageType,
          frequencydisplayname: eventInfo.Frequency || ''
        });
        this.selectedId = eventInfo.Id;
        this.selectedAgentguid = eventInfo.SourceAgent;
        this.statusvalue = (eventInfo.Status === true || eventInfo.Status === 'True') ? 'true' : 'false';
        this.deploymentSelected = eventInfo.Deployment;
        this.selectedChildRowId = null;
        // Enable all fields for parent edit
        this.eventInfoForm.get('eventType')?.enable({ emitEvent: false });
        this.eventInfoForm.get('deployment')?.enable({ emitEvent: false });
        this.eventInfoForm.get('dxEndpoint')?.enable({ emitEvent: false });
        this.eventInfoForm.get('frequencydisplayname')?.enable({ emitEvent: false });
      }
    } else {
      // Add new parent event
      this.agenttitle = "Add Event Info";
      this.selectedId = 0;
      this.selectedAgentguid = '';
      this.statusvalue = '';
      this.deploymentSelected = '';
      this.isParentAdd = true;
      this.isChildAdd = false;
      this.eventInfoForm.patchValue({
        eventType: '',
        deployment: '',
        status: false,
        dxEndpoint: '',
        messageType: '',
        frequencydisplayname: ''
      });
      // Enable all fields for add
      this.eventInfoForm.get('eventType')?.enable({ emitEvent: false });
      this.eventInfoForm.get('deployment')?.enable({ emitEvent: false });
      this.eventInfoForm.get('dxEndpoint')?.enable({ emitEvent: false });
      this.eventInfoForm.get('frequencydisplayname')?.enable({ emitEvent: false });
      this.reactiveFormdeployment.patchValue(this.deploymentItemsList);
    }

    const addOrEditModalRef = this.modalService.open(modal, {
      windowClass: eventInfo ? "eventinfo-modal-edit" : "eventinfo-modal-add",
      backdrop: 'static',
      keyboard: false
    });
    this.currentModalRefs.push(addOrEditModalRef);
    
    addOrEditModalRef.result.then(
      (result) => {
        this.modalWasOpen = false;
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== addOrEditModalRef);
        this.resetPage(false, false);
      },
      (reason) => {
        this.modalWasOpen = false;
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== addOrEditModalRef);
        this.resetPage(false, false);
      }
    ).finally(() => {
      this.resetPage(false, false);
    });
    
    this.modalTabVisibility.tagOwned('data-eventinfo-modal', eventInfo ? "eventinfo-modal-edit" : "eventinfo-modal-add");
    
    this.modalWasOpen = true;
  }

  openAddChildEventInfo(parent: any, modal: any): void {
    this.resetPage(false, false);
    this.eventInfoForm.reset();
    this.agenttitle = "Add Child Event Info";
    // Always set deployment to parent's value and disable
    const parentDeployment = parent?.Deployment || '';
    this.eventInfoForm.patchValue({
      eventType: parent?.EventType || '',
      deployment: parentDeployment,
      status: false,
      dxEndpoint: parent?.DXEndPoint ?? '',
      messageType: '',
      frequencydisplayname: parent?.Frequency || ''
    });
    this.selectedId = 0;
    this.selectedChildRowId = 0;
    this.selectedAgentguid = parent?.SourceAgent || '';
    this.deploymentSelected = parentDeployment;
    this.isParentAdd = false;
    this.isChildAdd = true;
    // Make parent fields read-only for child add
    this.eventInfoForm.get('eventType')?.disable({ emitEvent: false });
    this.eventInfoForm.get('deployment')?.disable({ emitEvent: false });
    this.eventInfoForm.get('dxEndpoint')?.disable({ emitEvent: false });
    this.eventInfoForm.get('frequencydisplayname')?.disable({ emitEvent: false });

   

    const addChildModalRef = this.modalService.open(modal, {
      windowClass: "eventinfo-modal-add-child",
      backdrop: 'static',
      keyboard: false
    });
    this.currentModalRefs.push(addChildModalRef);
    
    addChildModalRef.result.then(
      (result) => {
        this.modalWasOpen = false;
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== addChildModalRef);
        this.resetPage(false, false);
      },
      (reason) => {
        this.modalWasOpen = false;
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== addChildModalRef);
        this.resetPage(false, false);
      }
    ).finally(() => {
      this.resetPage(false, false);
    });
    
    this.modalTabVisibility.tagOwned('data-eventinfo-modal', 'eventinfo-modal-add-child');
    
    this.modalWasOpen = true;
  }

  saveEventInfo(modal: any): void {
    const performSave = () => {
      this.ngxUiLoaderService.start();
      const raw = this.eventInfoForm.getRawValue();
      const dxEndPoint = String(raw.dxEndpoint ?? this.eventInfoForm.get('dxEndpoint')?.value ?? '').trim();
      let statusValue = this.eventInfoForm.value.status;
      if (typeof statusValue === 'boolean') {
        statusValue = statusValue ? 'true' : 'false';
      } else if (typeof statusValue === 'object' && statusValue !== null && (statusValue as any).name !== undefined) {
        statusValue = (statusValue as any).name;
      } else if (typeof statusValue === 'string') {
        const lowered = statusValue.toLowerCase();
        statusValue = (lowered === 'active' || lowered === 'true') ? 'true' : 'false';
      } else {
        statusValue = 'false';
      }

      const isEditing = (this.selectedId !== 0) || (this.selectedChildRowId !== null && this.selectedChildRowId > 0);

      if (!isEditing) {
        // Add: all fields mandatory
        if (!raw.eventType || !raw.deployment || !dxEndPoint || !raw.messageType || !raw.frequencydisplayname || !this.selectedAgentguid) {
          this.ngxUiLoaderService.stop();
          this.toastr.warning('All fields are mandatory.', '', { timeOut: 4000, positionClass: 'toast-bottom-right' });
          return;
        }
        // If status not selected, default to passive
        if (!this.eventInfoForm.value.status) {
          statusValue = 'false';
        }
      } else {
        // Edit: only messageType mandatory
        if (!raw.messageType) {
          this.ngxUiLoaderService.stop();
          this.toastr.warning('Message Type is mandatory for update.', '', { timeOut: 4000, positionClass: 'toast-bottom-right' });
          return;
        }
      }

      let eventInfo: any = {
        Id: (this.selectedChildRowId !== null && this.selectedChildRowId > 0) ? this.selectedChildRowId : this.selectedId,
        EventType: raw.eventType,
        SourceAgent: this.selectedAgentguid,
        MessageType: raw.messageType,
        DXEndPoint: dxEndPoint,
        Status: statusValue,
        Deployment: raw.deployment,
        ModifierID: JSON.parse(sessionStorage.getItem('sessionObjectlogin') || '{"userdata":{}}').userdata['userid'],
        Frequency: raw.frequencydisplayname ? (raw.frequencydisplayname.displayname || raw.frequencydisplayname) : ''
      };
      // Add isChild property for child event add/edit
      if (this.isChildAdd || (this.selectedChildRowId !== null && this.selectedChildRowId > 0)) {
        eventInfo.isChild = true;
      }

  // Audit for parent event add will be done after API call, using response.EventMapId

      // Reset after save
      this.selectedChildRowId = null;

      this.service.UpdateInsertVAEventInfo(eventInfo).subscribe({
        next: (response: any) => {
          if (response && response.status === 'success') {
            this.toastr.success(response.statusmessage, '', {
              timeOut: 500,
              positionClass: 'toast-bottom-right'
            });
            this.resetPage(true, false);
            this.getVAEventInfo(false);
            // Save audit for parent add/edit, use EventMapId from response (insert/update)
            const contextId = !isEditing
              ? response.responsebody?.EventMapId
              : (response.EventMapId || eventInfo.EventMapId || eventInfo.VAEventSourceMap || eventInfo.Id);
            let auditDescription = '';
            if (!isEditing) {
              // Insert: log all inserted fields
              auditDescription = 'Parent Event: Inserted Event Info: ' + Object.entries(eventInfo)
                .map(([key, value]) => `${key}: ${value}`).join(', ');
              // Audit save removed as per request
            } else {
              // Update: log only changed fields
              let changedFields: string[] = [];
              const oldParent = this.vaEventInfoList.ParentEventInfo.find(p => p.EventMapID === eventInfo.Id);
              if (oldParent) {
                Object.keys(eventInfo).forEach(key => {
                  if (key !== 'ModifierID' && key !== 'Id' && eventInfo[key] !== undefined && eventInfo[key] !== oldParent[key]) {
                    changedFields.push(`${key}: '${oldParent[key]}' → '${eventInfo[key]}'`);
                  }
                });
              }
           
            }
          } else {
            this.service.copyableToastError(response.statusmessage);
          }
          this.ngxUiLoaderService.stop();
        },
        error: () => {
          this.ngxUiLoaderService.stop();
          this.toastr.error('Error occurred while saving Event Info.', '', { timeOut: 4000, positionClass: 'toast-bottom-right' });
        }
      });
    };

    const isEditing = (this.selectedId !== 0) || (this.selectedChildRowId !== null && this.selectedChildRowId > 0);
    const goingInactive = this.eventInfoForm.value.status === false;
    if (isEditing && goingInactive) {
      const dialogData = new ConfirmDialogModel('Confirm Action', 'Do you want to inactivate?', 'confirm', '');
      // Original ConfirmDialog open() included: scrollStrategy: this.overlay.scrollStrategies.noop() — left commented; shell scroll is handled globally (app / VSstyles).
      this.dialog.open(ConfirmDialogComponent, {
        maxWidth: '500px',
        data: dialogData,
        disableClose: true,
        panelClass: 'confirm-dialog-panel',
        // scrollStrategy: this.overlay.scrollStrategies.noop()
      }).afterClosed().subscribe(result => {
        if (result) {
          performSave();
        } else {
          // Revert toggle back to Active when cancelled
          this.eventInfoForm.get('status')?.setValue(true, { emitEvent: false });
        }
      });
    } else {
      performSave();
    }
  }
 
  onChildStatusToggle(child: any, isChecked: boolean): void {
    
    // Find parent details for required fields
    const parent = this.vaEventInfoList.ParentEventInfo.find(p => p.EventMapID === child.EventSourceMapID);
    const payload: any = {
      Id: child.ChildRowId || 0,
      EventType: parent ? parent.EventType : '',
      SourceAgent: parent ? parent.SourceAgent : '',
      MessageType: child.MessageType,
      DXEndPoint: parent?.DXEndPoint ?? '',
      Status: isChecked ? 'true' : 'false',
      Deployment: parent ? parent.Deployment : '',
      ModifierID: JSON.parse(sessionStorage.getItem('sessionObjectlogin') || '{"userdata":{}}').userdata['userid'],
      Description: !isChecked ? 'Child event inactivated' : 'Child event activated',
      isChild: true
    };

    const doToggle = () => {
      this.ngxUiLoaderService.start();
      
      this.service.UpdateInsertVAEventInfo(payload).subscribe({
        next: (response: any) => {
          this.ngxUiLoaderService.stop();
          if (response && response.status === 'success') {
            child.Status = isChecked;
            this.toastr.success('Status updated successfully', '', { timeOut: 500, positionClass: 'toast-bottom-right' });
            // Save audit for child activate/inactivate at parent level, with details
            const parent = this.vaEventInfoList.ParentEventInfo.find(p => p.EventMapID === child.EventSourceMapID);
            if (parent) {
              // Compare old and new status, log only changed fields
              let changedFields: string[] = [];
              if (child.Status !== (isChecked ? 'true' : 'false')) {
                changedFields.push(`Status: '${child.Status}' → '${isChecked ? 'true' : 'false'}'`);
              }
             
            }
          } else {
            child.Status = !isChecked;
            this.toastr.error(response?.statusmessage || 'Failed to update status', '', { timeOut: 4000, positionClass: 'toast-bottom-right' });
          }
        },
        error: () => {
          this.ngxUiLoaderService.stop();
          child.Status = !isChecked;
          this.toastr.error('Error occurred while updating status.', '', { timeOut: 4000, positionClass: 'toast-bottom-right' });
        }
      });
    };

    if (!isChecked) {
      const dialogData = new ConfirmDialogModel('Confirm Action', 'Do you want to inactivate?', 'confirm', '');
      // Original included scrollStrategy noop — see comment on first dialog.open in this file.
      this.dialog.open(ConfirmDialogComponent, {
        maxWidth: '500px',
        data: dialogData,
        disableClose: true,
        panelClass: 'confirm-dialog-panel',
        // scrollStrategy: this.overlay.scrollStrategies.noop()
      }).afterClosed().subscribe(result => {
        if (result) {
          doToggle();
        } else {
          child.Status = true;
        }
      });
    } else {
      doToggle();
    }
  }

  deleteEventInfo(eventId: number): void {
    const message = `Are you sure you want to delete this item?`;
    const dialogData = new ConfirmDialogModel("Confirm Action", message, 'confirm', '');
    // Original included scrollStrategy noop — see comment on first dialog.open in this file.
    this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "500px",
      data: dialogData,
      disableClose: true,
      panelClass: 'confirm-dialog-panel',
      // scrollStrategy: this.overlay.scrollStrategies.noop()
    }).afterClosed().subscribe(result => {
      if (result) {
        this.ngxUiLoaderService.start();
       
      }
    });
  }

  /**
   * Opens the audit modal for parent or child event info.
   * @param id The unique id (EventMapID or EventSourceMapID)
   * @param guid The guid (EventMapID or EventSourceMapID)
   * @param title The event type or message type
   */
  openAuditPopUp(id: number, guid: number, title: string): void {
    const auditDataToModal = {
      id: id,
      title: title,
      context: "VAEventInfo",
      type: "ID",
      guid: guid,
      userid: JSON.parse(sessionStorage.getItem('sessionObjectlogin') || '{"userdata":{}}').userdata['userid']
    };
    const auditModalRef = this.modalService.open(NewauditComponent,
      { windowClass: "myCustomModalClass", backdrop: 'static', keyboard: false });
    auditModalRef.componentInstance.inputDataInModalComponent = auditDataToModal;
    this.currentModalRefs.push(auditModalRef);
    
    auditModalRef.result.then(
      (result) => {
        this.modalWasOpen = false;
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== auditModalRef);
      },
      (reason) => {
        this.modalWasOpen = false;
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== auditModalRef);
      }
    );
    
    this.modalTabVisibility.tagOwned('data-eventinfo-modal', 'myCustomModalClass');
    
    this.modalWasOpen = true;
  }

  copyToClip(text: string, label?: string): void {
    const valueToCopy = text || '';
    if (!valueToCopy) { return; }
    const onDone = () => this.toastr.success(`${label || 'Text'} Copied`, '', { timeOut: 500, positionClass: 'toast-bottom-right' });
    const nav: any = navigator as any;
    if (nav && nav.clipboard && typeof nav.clipboard.writeText === 'function') {
      nav.clipboard.writeText(valueToCopy).then(onDone).catch(onDone);
      return;
    }
    const textarea = document.createElement('textarea');
    textarea.value = valueToCopy;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    try { document.execCommand('copy'); } catch {}
    document.body.removeChild(textarea);
    onDone();
  }
  openParentJobLogsModal(jobId: string, eventType: string, jobName: string) {
    this.modalJobName = jobName;
    this.modalJobId = jobId;
    this.modalJobLogs = this.parentJobLogs[jobId] || [];
    const jobLogsModalRef3 = this.modalService.open(this.parentJobLogsModal, {
      windowClass: 'job-logs-modal',
      size: 'lg',
      backdrop: 'static'
    });
    this.currentModalRefs.push(jobLogsModalRef3);
    
    jobLogsModalRef3.result.then(
      (result) => {
        this.modalWasOpen = false;
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== jobLogsModalRef3);
      },
      (reason) => {
        this.modalWasOpen = false;
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== jobLogsModalRef3);
      }
    );
    
    this.modalTabVisibility.tagOwned('data-eventinfo-modal', 'job-logs-modal');
    
    this.modalWasOpen = true;
  }

  hideModals() {
    const result = this.modalTabVisibility.hideOwned('data-eventinfo-modal', {
      hasOpenRefs: this.currentModalRefs?.length > 0,
      windowClasses: ['job-logs-modal', 'eventinfo-modal-edit', 'eventinfo-modal-add', 'eventinfo-modal-add-child', 'myCustomModalClass'],
    });
    this.modalWasOpen = result.modalWasOpen;
  }

  showModals() {
    this.modalTabVisibility.showOwned('data-eventinfo-modal', {
      modalWasOpen: this.modalWasOpen,
      hasOpenRefs: this.currentModalRefs?.length > 0,
      windowClasses: ['job-logs-modal', 'eventinfo-modal-edit', 'eventinfo-modal-add', 'eventinfo-modal-add-child', 'myCustomModalClass'],
    });
  }
}
